import { IEndpointData } from '@packages/toolbox/dist/declarations/endpoint';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';

/**
 * Эндпоинты live Excel по заявлениям.
 *
 * COLUMNS — live-поля актуального маршрута (`/services/{id}/issue-report-columns`).
 * GENERATE — реестр заявлений, POST `/reports/service/{id}/issues`.
 * Не путать GENERATE со старым GET `/reports/service/{id}` (фиксированные
 * колонки, сразу файл). GENERATE только ставит фоновую задачу.
 */
export default {
  COLUMNS(serviceId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${SERVER_API}/services/${serviceId}/issue-report-columns`,
    };
  },
  GENERATE(serviceId: number): IEndpointData {
    return {
      method: 'POST',
      url: `${SERVER_API}/reports/service/${serviceId}/issues`,
    };
  },
};
